export enum UIRoutes {
    OVERVIEW = '/',
    SIGN_IN = '/sign-in',
}
